"use strict";

exports.__esModule = true;
exports.ZoomOutButton = exports.ZoomLabel = exports.ZoomInButton = exports.StyledToolbarZoomNav = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ToolbarButton = _interopRequireDefault(require("../ToolbarButton/ToolbarButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledToolbarZoomNav = _styledComponents.default.div`
    display: flex;
    color: inherit;
`;
exports.StyledToolbarZoomNav = StyledToolbarZoomNav;
const ZoomOutButton = (0, _styledComponents.default)(_ToolbarButton.default)`
    margin-right: 0;
`;
exports.ZoomOutButton = ZoomOutButton;
const ZoomInButton = (0, _styledComponents.default)(_ToolbarButton.default)`
    margin-left: 0;
`;
exports.ZoomInButton = ZoomInButton;
const ZoomLabel = _styledComponents.default.p`
    display: block;
    padding: 15px 5px;
    margin: 0;
    font-size: 13px;
    line-height: 20px;
    min-width: 45px;
    text-align: center;
    cursor: default;
`;
exports.ZoomLabel = ZoomLabel;